import React, {useState} from "react";
import { useNavigate } from 'react-router-dom';
// import api from "../Api";
import Cookies from 'js-cookie';
import axios from "axios";
import APIURL from '../components/Constant'
import Popup from "../components/PopUP";

export default function ForgetPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  

  const handleSubmit = async () => {
    setLoading(true)
    if (!email) {
        setError("Email is required");
        setLoading(false)
        return; 
    }

    try {
        const response = await axios.post(APIURL+"/user-service/auth/admin-forget-password", { email });
        console.log("Response:", response.data);
        setPopupMessage(response.data.detail)
        Cookies.set('forget_email', email, { expires: 1/24 }); // Expires in 1 hour
        setLoading(false)

        setTimeout(() => {
            navigate('/verify');
        }, 3000);

    } catch (error) {
        console.log(error)
        setError(error.response && error.response.data ? error.response.data.detail || "Something wrong please try again." : "Something wrong please try again.");
        setLoading(false)
    }

  }

    return (
        <>
        <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
        <div className="credential_main_wrapper">
            <div className="credential_content_outer">
            <div className="credential_content_wrapper">
                <div className="credential_logo">
                <img src="assets/images/logo-white.svg" alt="Logo" />
                </div>
            </div>
            </div>
            <div className="credential_form_wrapper">
            <div className="credential_form_card">
                <div className="credential_content_info">
                <h1>Forgot Password</h1>
                <p className="mb-0 credential_sub_heading">
                    Please enter your email address
                </p>
                </div>
                <form>
                <div className="form_field_wrapper">
                    <div className="form_field">
                    <label htmlFor="email">Email address</label>
                    <div className="input_field">
                        <input
                        type="email"
                        className="form-control"
                        name="Email"
                        id="email"
                        placeholder="Enter your email address"
                        onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    {error && <span className="error">{error}</span>}
                    </div>
                </div>
                <div className="form-btn-blk">
                    {loading ? 
                    <button
                    type="button"
                    className="form-btn w-100 fw-bold text-white text-capitalize"
                    disabled
                    >
                    Reset Password
                    </button>
                    : 
                    <button
                    type="button"
                    className="form-btn w-100 fw-bold text-white text-capitalize"
                    onClick={handleSubmit}
                    >
                    Reset Password
                    </button>
                    }
                </div>
                </form>
            </div>
            </div>
        </div>
        </>
    )
}